import { globalStyles } from "shared/constants";
const { background, flex } = globalStyles;

const sidebarHeaderStyles = {
  drawerPaper: {
    padding: "16px",
    ...background.color.primary.dark,
    ...flex.justify.between,
  },
};

export default sidebarHeaderStyles;
